import React, { useContext, useMemo } from 'react';

import ReportGadgetsContext from '../../../contexts/ReportGadgetsContext';
import VisualisationCacheContext from '../../../contexts/VisualisationCacheContext';

const ReportGadgetsProvider = ({
  children,
}: {
  children: JSX.Element | JSX.Element[];
}) => {
  const { cache } = useContext(VisualisationCacheContext);

  const allGadgets = useMemo(
    () => Array.from(cache.reportGadgets.values()),
    [cache],
  );

  const reportGadgetsLookup = useMemo(() => {
    const lookup: {
      [id: string]: ReportGadgets.ReportGadget | undefined;
    } = {};
    allGadgets.forEach((g) => {
      lookup[g.id] = g;
    });
    return lookup;
  }, [allGadgets]);

  return (
    <ReportGadgetsContext.Provider
      value={{
        allGadgets,
        isLoading: false,
        reportGadgetsLookup,
      }}
    >
      {children}
    </ReportGadgetsContext.Provider>
  );
};

export default ReportGadgetsProvider;
